import React from 'react';
import { RadioGroupSC } from './radio.styled';
import { RadioGroupProps } from './radio.types';
import { RadioGroupContextProvider } from './radio.utils';
import classNames from 'classnames';

const RadioGroup = <T extends any>(
  {
    onChange,
    value,
    disabled,
    children,
    style,
    className,
    layout = 'vertical',
    name,
  }: RadioGroupProps<T>,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const onRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange && e.target.value !== value) {
      onChange(e);
    }
  };
  const isVertical = layout === 'vertical';

  return (
    <RadioGroupContextProvider
      value={{
        onChange: onRadioChange,
        value,
        disabled,
        name,
      }}
    >
      <RadioGroupSC
        ref={ref}
        style={style}
        className={classNames('ui-radio-group', className, {
          'radio-group-vertical': isVertical,
          'radio-group-horizontal': !isVertical,
        })}
        layout={layout}
      >
        {children}
      </RadioGroupSC>
    </RadioGroupContextProvider>
  );
};

export default React.forwardRef(RadioGroup);
